var map = {
	"./frontend/AndroidGuide.vue": 7881,
	"./frontend/BetslipHistory.vue": 2947,
	"./frontend/BodyFB.vue": 9957,
	"./frontend/ContactUs.vue": 5571,
	"./frontend/DataTable.vue": 6107,
	"./frontend/Deposit.vue": 808,
	"./frontend/FinishedMatches.vue": 299,
	"./frontend/History.vue": 4575,
	"./frontend/Home.vue": 4958,
	"./frontend/IOSGuide.vue": 7508,
	"./frontend/Iframe.vue": 2251,
	"./frontend/Index.vue": 7217,
	"./frontend/Live.vue": 5586,
	"./frontend/LiveScore.vue": 2184,
	"./frontend/MainMenu.vue": 7294,
	"./frontend/MaungFB.vue": 3867,
	"./frontend/Promotion.vue": 6921,
	"./frontend/Setting.vue": 9056,
	"./frontend/TwodThreed.vue": 650,
	"./frontend/VideoLink.vue": 8098,
	"./frontend/Withdraw.vue": 5098,
	"./frontend/auth/Login.vue": 704,
	"./frontend/auth/Rule.vue": 6397,
	"./frontend/components/AccountSelect.vue": 3678,
	"./frontend/components/DataTable.vue": 3713,
	"./frontend/components/FBPreviewVoucher.vue": 3376,
	"./frontend/components/FBVoucher.vue": 4314,
	"./frontend/components/FootballTeamCard.vue": 4973,
	"./frontend/components/GroupBox.vue": 8747,
	"./frontend/components/InputSelectDrawModal.vue": 1307,
	"./frontend/components/LuckyWheel.vue": 187,
	"./frontend/components/NormalBox.vue": 9250,
	"./frontend/components/PreviewVoucher.vue": 3037,
	"./frontend/components/SideNav.vue": 850,
	"./frontend/components/Table.vue": 9763,
	"./frontend/components/ThreedGroupBox.vue": 5959,
	"./frontend/components/TwoDSelect.vue": 3841,
	"./frontend/components/Voucher.vue": 30,
	"./frontend/normal-user/2d/2d.vue": 543,
	"./frontend/normal-user/2d/ClosedDays.vue": 156,
	"./frontend/normal-user/2d/Home.vue": 9405,
	"./frontend/normal-user/2d/Winner.vue": 7807,
	"./frontend/normal-user/3d/3d.vue": 6660,
	"./frontend/normal-user/3d/Home.vue": 6470,
	"./frontend/normal-user/DreamBooks.vue": 4010,
	"./frontend/normal-user/Index.vue": 6012,
	"./frontend/normal-user/bugyee/Room.vue": 7576,
	"./frontend/normal-user/game/Fishing.vue": 1879,
	"./frontend/normal-user/game/Game.vue": 1217,
	"./frontend/normal-user/game/Slot.vue": 1113,
	"./frontend/normal-user/shankomee/Room.vue": 703
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5477;